
/**
 * Module dependencies.
 */

import BigNumber from 'bignumber.js';

/**
 * Export `roundDown`.
 */

export function roundDown(value: number | string | BigNumber, decimalPlaces?: number | null | undefined): string {
  return new BigNumber(value).toFixed(decimalPlaces ?? 2, BigNumber.ROUND_DOWN);
}

/**
 * Export `roundUp`.
 */

export function roundUp(value: number | string | BigNumber, decimalPlaces?: number | null | undefined): string {
  return new BigNumber(value).toFixed(decimalPlaces ?? 2, BigNumber.ROUND_UP);
}
